<template>
  <Modal class="mask" class-name="vertical-center-modal" v-model="show" :mask-closable="false">
    <div slot="header" class="modal-header">取消维修单</div>
    <div>
      <Form :model="formData" :label-width="90"  :rules="formRules" ref="formData">
        <FormItem label="取消原因" prop="code">
          <Select v-model="formData.code" :label-in-value="true" class="item-width" placeholder="请选择取消原因">
            <Option v-for="item in cancleResonList" :value="item.value" :key="item.value">{{item.text}}</Option>
          </Select>
        </FormItem>
        <FormItem label="备注" prop="description">
          <Input v-model="formData.description" class="item-width" >
          </Input>
        
        </FormItem>

      </Form>
    </div>
    <div slot="footer">
      <Button type="text" size="large" @click="handleCancel">取消</Button>
      <Button type="primary" size="large" @click="confirm" :loading="loading">
        <span>确定</span>
      </Button>
    </div>
  </Modal>
</template>
<script type="text/ecmascript-6">
import { getCancelReasonList,cancelRepairOrder } from 'api/repaire'

export default {
  created(){
    getCancelReasonList().then( res => {
      this.cancleResonList = res.data
    })
  },
  props:{
    n:{
      type:Number,
      default:0
    },
    order_sn:{
      type:String,
      default:''
    }    
  },
  data () {
  return {
    show:false,
    loading:false,
    cancleResonList:[],
    formData:{
      code:'',
      description:''
    },
    formRules:{
      code:[{ required: true, message:'请选择取消原因', trigger:"change" }],
      description:[{required: false, message:'请填写取消备注', trigger:"blur"}]
    }
 };
 },
 watch:{
   n(val){
     this.show = true;
     this.$refs['formData'].resetFields();
   }
 },
 methods:{
   handleCancel(){
      this.show = false
    },
   confirm(){
     
     // 调接口
      this.$refs['formData'].validate( bool => {
        if(bool){
          this.loading = true
          let params = {
            order_sn: this.order_sn,
            code: this.formData.code,
            description: this.formData.description
          }
          cancelRepairOrder(params).then(res => {
            this.show = false
            this.$Message.success('取消订单成功')
            this.$emit('refresh')
          }).finally( () => {
            this.loading = false
          })
        }
      })
     
    }
 }
}
</script>


